import { useCallback, useContext } from "react";
import {
  getIconValueDefinitions,
  getLayerSymbology,
} from "../../../../../utils/symbologies";
import {
  iconNameToIcon,
  svgToBase,
} from "../../../../Icons/layerSvg/clusterAssets";
import { LayerIconWrapper } from "../../../../ManualWidgets/ManualWidget-styled";
import { StyledList, StyledListItem, StyledTitle } from "../../Editor-styled";
import { EditorContext } from "../../EditorContextProvider";

const AerodromeClass = ({ layer, config, handleSelection, t, type }) => {
  const { activeColor } = useContext(EditorContext);
  const renderFields = useCallback(() => {
    if (!type) return [];

    const symbology = getLayerSymbology(layer, config);
    const iconValueDefinition = getIconValueDefinitions(symbology, layer, 1, t);
    const filteredIconDefinition = iconValueDefinition.filter((item) => {
      const [aerodromeClass, aerodromeType] = item.value.split(",");
      return aerodromeType == type;
    });

    return filteredIconDefinition.map((item) => {
      const [code] = item.value.split(",").map((value) => Number(value));
      return {
        code: Number.isFinite(code) ? code : 0,
        icon: svgToBase(item.icon, symbology.defaultColor),
        label: item.label,
        iconName: item.icon,
        fieldName: "aerodromeclass",
      };
    });
  }, [layer, type, config, t]);

  return (
    <div style={{ paddingTop: "8px" }}>
      <StyledTitle>Select Aerodrome class</StyledTitle>
      <StyledList>
        {renderFields().map((item, index) => {
          const icon = iconNameToIcon(item.iconName);
          return (
            <StyledListItem
              key={`${item.label}-${index}`}
              onClick={() => {
                handleSelection(item);
              }}
            >
              <LayerIconWrapper
                width={40}
                height={40}
                fill="rgb(73, 73, 73)"
                opsColor="rgb(73, 73, 73)"
                dangerouslySetInnerHTML={{ __html: icon }}
                config={config}
                circleColor="transparent"
              />
              <span>{item.label}</span>
            </StyledListItem>
          );
        })}
      </StyledList>
    </div>
  );
};

export default AerodromeClass;
